import Spinner from "react-bootstrap/Spinner";

const CustomSpinner = ({ variant, className }) => {
  return <Spinner animation="border" variant={variant} className={className} />;
};

export default CustomSpinner;
